module.exports = __webpack_public_path__ + "static/media/export-file.7a8cee51.png";